import api from "@/lib/api";

export default {
  getAll(userId) {
    return api.get("/api/v1/planner/funnel/get-all", { params: { any: userId } });
  },
  create(funnel) {
    return api.post("/api/v1/planner/funnel/create", funnel);
  },
  update(funnel) {
    return api.put("/api/v1/planner/funnel/update", funnel);
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/planner/funnel/delete", { params: { ids } });
  },
};


